import {
  isCookieEnabled as _isCookieEnabled,
  getCookie as _getCookie,
  setCookie as _setCookie,
  setRawCookie as _setRawCookie,
  removeCookie as _removeCookie,
} from 'tiny-cookie';

const isCookieEnabled = _isCookieEnabled();

const normalizeOptions = (options) => {
  if (!options) {
    return options;
  }
  if (!options.domain || options.domain === 'localhost') {
    const safeOptions = { ...options };
    delete safeOptions.domain;
    return safeOptions;
  }
  return options;
};

const encode = (value) => {
  try {
    if (!value) {
      return null;
    }
    const encodedValue = JSON.stringify(value);
    return encodedValue;
  } catch {
    return null;
  }
};

const decode = (value) => {
  try {
    if (!value) {
      return null;
    }
    const decodedValue = JSON.parse(value);
    return decodedValue;
  } catch {
    return null;
  }
};

const hasCookie = (key) => {
  const cookie = decode(_getCookie(key));
  return !(cookie === 'undefined' || cookie === undefined || cookie === null);
};

const hasRawCookie = (key) => {
  const cookie = _getCookie(key);
  return !(cookie === 'undefined' || cookie === undefined || cookie === null);
};

const getCookie = (key) => _getCookie(key, decode);
const getRawCookie = (key) => _getCookie(key);
const setCookie = (key, value, options) => _setCookie(key, value, encode, normalizeOptions(options));
const setRawCookie = (key, value, options) => _setRawCookie(key, value, normalizeOptions(options));
const removeCookie = (key, options) => _removeCookie(key, normalizeOptions(options));

export {
  isCookieEnabled,
  hasCookie,
  getCookie,
  getRawCookie,
  hasRawCookie,
  setCookie,
  setRawCookie,
  removeCookie,
};
